import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { chunk } from '../helpers'

import { Row, Content } from '../components/Layout.js'
import Hero from '../components/Hero'
import Card from '../components/Card'
import Footer from '../components/Footer'
import Button from '../components/Button'
import Hex from '../components/Hex'

const heroOptions = {
  header: 'Careers @bronzelabs.',
  subtext: 'We’re always looking for talented, versatile and passionate people itching to bring their ideas into the universe.',
  background: 'careers_bg'
  // backgroundImage
}

class Careers extends Component {
  componentWillMount () {
    setTimeout(() => this.props.setModal(false), 800)
  }

  render () {
    const reasons = chunk(this.props.careerReasons, 2)
    return (
      <div className='mainContainer'>
        <Hero options={heroOptions} />
        <section className='noTopPadding'>
          <Row classes={['marginBottom']}>
            <Content><span>We are an award-winning software development company based in Telford, Shropshire, creating mobile applications and digital platforms for our customers. At Bronze, we have a philosophy of constant progression as a company and as a team, our culture is founded upon openness and the ability for all crew members to make suggestions and feel heard. As the team grows it is important that this is maintained and drives us forward as a company.</span></Content>
            <Content><span>A key project at Bronze Labs is a digital platform called Tribe, it makes local support easily accessible and creates new support networks and employment opportunities in isolated communities. We are using technology to improve lives, ensuring those dependent on support can access high-quality, high-value services; while promoting preventative support groups that address social isolation and allow people to live independently for longer.</span></Content>
          </Row>
          <Row>
            <Content classes={['contentFull']}>
              <h2>Want to join us? Here's what to expect.</h2>
            </Content>
          </Row>
          <Row classes={['marginBottom']}>
            <Content classes={['contentFull']}>
              {
                reasons.map((row, rowIndex) => (
                  <div className='hexRow' key={rowIndex}>
                    {
                      row.map((item, index) => (
                        <Hex key={index} text={item.text} number={(index + 1) + (rowIndex * 2)} />
                      ))
                    }
                  </div>
                ))
              }
            </Content>
          </Row>
          <Row>
            <Content>
              <h2>We're hiring!</h2>
            </Content>
          </Row>
          <Row classes={['marginBottom']}>
            {
              this.props.jobs.map((card, index) => <Content key={index}><Card options={card} modalLink /></Content>)
            }
          </Row>
          <Row>
            <Content>
              <h2>No agencies!</h2>
              <p>We do not use agencies to hire our talented team members as we like to hire based on more than a CV.</p>
              <p>Using an agency for our hiring procedure could damage our culture and work ethics, so we shall never use them.</p>
            </Content>
            <Content>
              <h2>Interested?</h2>
              <p>Even if we don’t have any current positions available, we still want to hear from you.</p>
              <Button icon='ac-mail' classes={['button-primary']} text='Send us an email' href='mailto:iwant2work@bronzelabs.co.uk?subject=I want to work at Bronze Labs&body=Hello, I would love a career at Bronze Labs with you guys. Please find my CV attached for your consideration and a bit about me below!' />
            </Content>
          </Row>
        </section>
        <Footer />
      </div>
    )
  }
}

Careers.propTypes = {
  setModal: PropTypes.func.isRequired,
  careerReasons: PropTypes.arrayOf(PropTypes.object).isRequired,
  jobs: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default Careers



// WEBPACK FOOTER //
// ./src/containers/Careers.js